<script>
import {getStbReq, upsetStbReq} from "@/api/setting";

export default {
  name: 'Setting',
  data() {
    return {
      stbReq: false
    }
  },
  mounted() {
    this.fetchStbReq()
  },
  methods: {
    async fetchStbReq(){
      const resp = await getStbReq()
      this.stbReq = resp.result
    },

    async changeStbReq(val) {
      const resp = await upsetStbReq()
      if (resp && resp.code === "0000"){
        this.$message.success("更新成功")
        this.stbReq = val
      }
    }
  }
}

</script>

<template>
  <div>
    <el-card title="系统设置" class="setting-card">
      <el-form label-width="200px">
        <el-form-item label="佛山无废平台请求开关">
          <el-tooltip>
            <template #content>
              <p>开启后，系统将向佛山无废平台发送请求</p>
            </template>
          </el-tooltip>
          <el-switch v-model="stbReq" active-color="#13ce66" inactive-color="#ff4949" :active-value="true" :inactive-value="false" @change="changeStbReq" />
        </el-form-item>
      </el-form>
    </el-card>
  </div>

</template>

<style scoped>
.setting-card{
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
  .el-card__body {
    flex: 1;
    width: 100%;
    height: 100%;
  }

}

</style>
